import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getConfigurationValue } from '@common/Utility/common-utils';
import Image from 'next/image';
import { isRTL, useTranslation } from '@common/i18n';
import { DOWNLOAD_APP_HAND_MOBILE, DOWNLOAD_APP_HAND_REVERSE_LARGE, IC_ANDROID, IC_HUAWEI, IC_IOS } from '@common/Assets/images';
import { FLAGSMITH_KEYS, ONE_ASTER_CATEGORY, ONLINE_PHARMACY_ROUTE } from '@common/Utility/constants';
import { flagsmith } from '@common/Lib/Flagsmith';
import Link from 'next/link';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getLangCodeFromUrl } from '../../../i18n';
import DownloadAppModal from '@common/Component/DownloadAppModal/DownloadAppModal';
import { useRouter } from 'next/router';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';

const DownloadAppBanner = (props) => {
  const t = useTranslation();
  const generateURL = useNavigationURL();
  const router = useRouter();
  const [currentLang, setCurrentLang] = useState('');
  const [showDownloadApp, setShowDownloadApp] = React.useState(false);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  useEffect(() => {
    if(typeof window !== 'undefined'){
      setCurrentLang(getLangCodeFromUrl());
    }
  }, []);

  const openDownloadAppPopup = () => {
      dataLayerSendEvent('app_download_popup_view', {
        screen_name: props?.screenName,
        page_type: props?.pageType,
        location: 'plp banner',
        myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
      });
  
      setShowDownloadApp(true)
    }

    const onDownloadButtonClick = (buttonName = '') => {
        dataLayerSendEvent('app_download_button_click', {
          screen_name: props?.screenName,
          page_type: props?.pageType,
          myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
          button_location: "plp banner",
          button_name: buttonName
        });
      }

  return (
    <div className={`download-app-banner ${currentLang && isRTL(currentLang) ? 'rtl' : ''}`}>
      <div className="banner-title" onClick={openDownloadAppPopup}>{t('DownloadAppSection.bannerTitle')}</div>
      <div className="banner-subtitle">{t('DownloadAppSection.bannerSubTitle')}</div>
      <div className='app-icon-wrapper'>
        {web_feature_flaging?.isAndroidStoreLinkEnable &&
          <Link
            passHref
            href={
              getConfigurationValue(appConfigData, 'androidPatientAppUrl')
                ? `${getConfigurationValue(appConfigData, 'androidPatientAppUrl')}`
                : generateURL(ONLINE_PHARMACY_ROUTE)
            }
          >
            <a target="_blank" onClick={() => onDownloadButtonClick('Google Play')}>
              <Image src={IC_ANDROID} alt="" />
            </a>
          </Link>
        }
        {web_feature_flaging?.isIOSStoreLinkEnable &&
          <Link
            passHref
            href={
              getConfigurationValue(appConfigData, 'iosPatientAppUrl')
                ? `${getConfigurationValue(appConfigData, 'iosPatientAppUrl')}`
                : generateURL(ONLINE_PHARMACY_ROUTE)
            }
          >
            <a target="_blank" onClick={() => onDownloadButtonClick('App Store')}>
              <Image src={IC_IOS} alt="" />
            </a>
          </Link>
        }
        {web_feature_flaging?.isHuaweiStoreLinkEnable &&
          <Link
            passHref
            href={
              getConfigurationValue(appConfigData, 'huaweiPatientAppUrl')
                ? `${getConfigurationValue(appConfigData, 'huaweiPatientAppUrl')}`
                : generateURL(ONLINE_PHARMACY_ROUTE)
            }
          >
            <a target="_blank">
              <Image src={IC_HUAWEI} alt="" />
            </a>
          </Link>
        }
        {
          <div className={`hand-mobile-img-wrappoer`}>
            <Image src={currentLang && isRTL(currentLang) ? DOWNLOAD_APP_HAND_REVERSE_LARGE : DOWNLOAD_APP_HAND_MOBILE} alt="" />
          </div>
        }
      </div>
      {showDownloadApp &&
        <DownloadAppModal 
          setShowDownloadApp={setShowDownloadApp} 
          location={'plp banner'} 
          screenName={props?.screenName} 
          pageType={props?.pageType} 
          buttonLocation="plp banner"
        />
      }
    </div>
  )
}

export default DownloadAppBanner;